<template>
    <div class="badge-status-stock">
        <span class="badge-chip bg-kit" v-if="itemRent.type == 4">Kit</span>
        <span v-else v-for="(b, i) in badges" :key="i" class="badge-chip" :class="b.className"
            :title="b.title || b.text" @click="onBadgeClick(b)">
            {{ b.text }}
        </span>
    </div>
</template>

<script>

import { mapMutations } from "vuex";

export default {
    name: "BadgeStatusStock",
    props: {
        itemRent: {
            type: Object,
            required: true
        }
    },
    computed: {
        badges() {
            const {
                type,
                statusRental,
                statusStockItemsRent,
                totalMaterialRented,
                totalMaterialReturned,
                serviceDone
            } = this.itemRent || {};

            const out = [];

            if (type === 5) {
                if (statusRental !== 2) {
                    out.push({ text: "Material", className: "bg-material" });
                } else {
                    if (statusStockItemsRent === 5) {
                        out.push({ text: "Mat… Realizado", className: "bg-material" });
                    }
                    if (totalMaterialRented === 0 && statusStockItemsRent !== 7) {
                        out.push({ text: "Material Pendente", className: "bg-pending" });
                    }
                    if (totalMaterialRented !== totalMaterialReturned && statusStockItemsRent !== 7) {
                        out.push({ text: "Mat… Pendente", className: "bg-pending" });
                    }
                }
                return out;
            }

            if (type === 3) {
                if (statusRental !== 2) {
                    out.push({ text: "Serviço", className: "bg-pending" });
                } else {
                    if (!serviceDone) out.push({ text: "Serv… Pendente", className: "bg-pending" });
                    else out.push({ text: "Serv… Realizado", className: "bg-service" });
                }
                return out;
            }

            // Novos status
            if (statusStockItemsRent === 1) out.push({ text: "Não Reservado", className: "bg-available" }); // Available
            if (statusStockItemsRent === 2) out.push({ text: "Reservado", className: "bg-reserved" }); // Reserved
            if (statusStockItemsRent === 3) out.push({ text: "Locado", className: "bg-rent" }); // Rented
            if (statusStockItemsRent === 4) out.push({ text: "Locado Parcial", className: "bg-rent" }); // PartialRented
            if (statusStockItemsRent === 5) out.push({ text: "Retornado", className: "bg-returned" }); // Returned
            if (statusStockItemsRent === 6) out.push({ text: "Retornado Parcial", className: "bg-partial-returned" }); // PartialReturned
            if (statusStockItemsRent === 7) out.push({ text: "Não Reservado", className: "bg-available" }); // NoStatus
            if (statusStockItemsRent === 8) out.push({ text: "Manutenção", className: "bg-maintenance" }); // Maintenance
            if (statusStockItemsRent === 9) out.push({ text: "Sem Movimentação", className: "bg-no-movement" }); // NoMovement

            return out;
        }
    },
    methods: {
        ...mapMutations("generic", ["addEvent"]),
        onBadgeClick() {
            this.addEvent({ name: "totalizationAndHistory", data: this.itemRent });
        }
    }
};
</script>

<style scoped>
.badge-status-stock {
    display: inline-flex;
    flex-wrap: wrap;
    gap: 6px;
}

.badge-chip {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 6px 10px;
    font-size: 12px;
    line-height: 1;
    color: #fff;
    border-radius: 9999px;
    user-select: none;
    white-space: nowrap;
    cursor: pointer;
    transition: transform 0.15s ease;
}

.bg-material {
    background-color: #812805;
}

.bg-pending {
    background-color: #F1BC31;
}

.bg-kit {
    background-color: #525E7B;
}

.bg-service {
    background-color: #df800d;
}

.bg-available {
    background-color: #8fbc8f;
}

.bg-reserved {
    background-color: #008b8b;
}

.bg-rent {
    background-color: #00008b;
}

.bg-returned {
    background-color: #b8860b;
}

.bg-partial-returned {
    background-color: #b8860b;
}

.bg-renewed {
    background-color: #1c1cc5;
}
.bg-maintenance {
    background-color: #e67e22;
}
.bg-no-movement {
    background-color: #a0a0a0;
    opacity: 0.6;
}
</style>
